import React from 'react';
import { IconBaseProps } from 'react-icons/lib';

const Icon = (props: IconBaseProps) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15.3126 11.5625C15.4963 11.5625 15.6632 11.6694 15.7391 11.8372C15.8151 12.005 15.7869 12.2019 15.6651 12.3397L12.3838 16.0897C12.2947 16.1909 12.1663 16.25 12.0313 16.25C11.8963 16.25 11.7679 16.1919 11.6788 16.0897L8.39756 12.3397C8.27662 12.2009 8.24662 12.005 8.32349 11.8372C8.39943 11.6703 8.56631 11.5625 8.75006 11.5625H10.6251V5.46875C10.6251 5.21 10.8351 5 11.0938 5H12.9688C13.2276 5 13.4376 5.21 13.4376 5.46875V11.5625H15.3126ZM17.1875 16.25C17.1875 15.7322 17.6072 15.3125 18.125 15.3125C18.6428 15.3125 19.0625 15.7322 19.0625 16.25V19.0625C19.0625 19.5809 18.6434 20 18.125 20H5.9375C5.42 20 5 19.5809 5 19.0625V16.25C5 15.7322 5.41973 15.3125 5.9375 15.3125C6.45527 15.3125 6.875 15.7322 6.875 16.25V18.125H17.1875V16.25Z"
			fill={props.color}
		/>
	</svg>
);

export default Icon;
